import { contains, path } from 'ramda';
import { bindActionCreators } from 'redux';

import { deviceTypes } from 'z-js-commons';
import { add } from '../../actions/tutorials';

export default (dispatch, deviceType = deviceTypes.DESKTOP, tutorialsInformations = [], alreadySeenTutorialsIds = [], page) => {
    const onDone = bindActionCreators(add, dispatch);
    return tutorialsInformations
        .filter(tutorialInformations => (tutorialInformations.pages && tutorialInformations.pages.includes(page)) || !tutorialInformations.pages || !page)
        .map(tutorialInformations => ({
            onDone,
            isAlreadySeen: contains(path(['info', 'tutorialName'], tutorialInformations), alreadySeenTutorialsIds),
            shouldOpenOnLoad: !!(tutorialInformations.autoOpen && alreadySeenTutorialsIds.length === 0),
            ...tutorialInformations.info,
            ...(tutorialInformations[deviceType] ? tutorialInformations[deviceType] : tutorialInformations[deviceTypes.PHONE])
        }));
};
